import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 9.5,
			width: 18,
			height: 12,
			rx: 3,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.5674,
			y: 13.0295,
			width: 2.86516,
			height: 4.94095,
			rx: .594581,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 6.5C7 4.84315 8.34315 3.5 10 3.5H14C15.6569 3.5 17 4.84315 17 6.5V9.5H7V6.5Z",
			stroke: "currentColor",
			strokeWidth: 1.5
		})
	]
});
export default SvgLock;
